import PropTypes from 'prop-types'
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



import IconSVG from 'svg-inline-react'

const InboxDropdown = React.createClass({
  displayName: 'InboxDropdown',
  propTypes: {
    inboxes: PropTypes.array.isRequired,
    onClickOutside: PropTypes.func.isRequired,
    onSelectInbox: PropTypes.func
  },

  clickInbox(inbox) {
    this.props.onSelectInbox(inbox)
    return this.props.onClickOutside()
  },

  createInboxDropdown() {
    return (
      <div>
        <div className="selection-header">
          Inboxes
        </div>
        {_.map(this.props.inboxes, (inbox, i) => {
          return (
            <div key={i} className="row" onClick={this.clickInbox.bind(this, inbox)}>
              <IconSVG
                className="mailbox-icon"
                src={require('!svg-inline?removeTags=true!images/icons/envelope-icon.svg')} />
              <div>
                {inbox.name}
              </div>
            </div>
          )
        })}
      </div>
    )
  },


  render() {
    return (
      <div className="InboxDropdown" onClick={this.handleOnClick}>
        {this.createInboxDropdown()}
      </div>
    )
  }

})

export default InboxDropdown



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/InboxDropdown.js